import React from 'react';

function Audio({ controls = false, audioSrc, audioRef = null, loop = false, autoPlay = false }) {
  return (
    <audio ref={audioRef} controls={controls} loop={loop} autoPlay={autoPlay}>
      <track kind="captions" srcLang="es" label="Español" default />
    </audio>
  );
}

export default Audio;
